import type {
  ValidationResult,
  YachtGameState,
  YachtToggleHoldAction,
} from "../types";
import { isValidDieIndex } from "../utils";
import {
  getOpenTurnSlot,
  invalid,
  valid,
  validateActionWindow,
} from "./common";

export function validateToggleHold(
  state: YachtGameState,
  action: YachtToggleHoldAction,
): ValidationResult {
  if (state.phase !== "ROLLING") {
    return invalid("Game is not rolling");
  }

  const slot = getOpenTurnSlot(state, action.playerId);
  if (!slot) {
    return invalid("Player does not have an open turn slot");
  }

  const windowValidation = validateActionWindow(slot, action);
  if (!windowValidation.valid) return windowValidation;

  if (slot.rollCount === 0) {
    return invalid("Cannot hold before the first roll");
  }

  if (slot.rollCount >= 3) {
    return invalid("Cannot hold after the third roll");
  }

  if (!isValidDieIndex(action.dieIndex)) {
    return invalid("Die index must be between 0 and 4");
  }

  if (slot.dice[action.dieIndex] === null) {
    return invalid("Cannot hold an empty die");
  }

  return valid();
}
